import { render, staticRenderFns } from "./UdefArticleCard.vue?vue&type=template&id=0e1d5dc3&scoped=true&"
import script from "./UdefArticleCard.vue?vue&type=script&lang=js&"
export * from "./UdefArticleCard.vue?vue&type=script&lang=js&"
import style0 from "./UdefArticleCard.vue?vue&type=style&index=0&id=0e1d5dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d5dc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
